<div class="top">
  <div class="heading">
    <span class="fw-bold">CREATE PARK</span>
  </div>
  <i class="material-icons text-danger" role="button" (click)="closeModal()">
    close
  </i>
</div>

<div class="form-wrapper">
  <form [formGroup]="form" (ngSubmit)="openConfirmModal()">
    <div class="form-fields">
      <div class="row">
        <div class="col-md-12">
          <div class="field">
            <label for="name" class="required">PARK NAME</label>
            <input
              type="text"
              class="form-control"
              formControlName="parkName"
              placeholder="park name"
            />
            <app-error-message
              [form]="form"
              controlName="parkName"
              label="park name"
              [showErrorMessage]="showErrorMessages"
            ></app-error-message>
          </div>
        </div>
        <div class="col-md-12">
          <div class="field">
            <label for="name" class="required">LGA</label>

            @if(!lgas){
            <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
            } @else{

            <ng-select
              [items]="lgas"
              [multiple]="false"
              [closeOnSelect]="true"
              [searchable]="true"
              [hideSelected]="false"
              bindLabel="formattedName"
              bindValue="id"
              placeholder="Select"
              formControlName="lga"
              (change)="loadArea($event)"
              class="ng-select control role-select"
            >
            </ng-select>

            }
            <app-error-message
              [form]="form"
              controlName="lga"
              label="LGA"
              [showErrorMessage]="showErrorMessages"
            ></app-error-message>
          </div>
        </div>
        <div class="col-md-12">
          <div class="field">
            <label for="name" class="required">AREA</label>

            @if(!areas){
            <ngx-skeleton-loader class="input-skeleton"></ngx-skeleton-loader>
            } @else{

            <ng-select
              [items]="areas"
              [multiple]="false"
              [closeOnSelect]="true"
              [searchable]="true"
              [hideSelected]="false"
              bindLabel="formattedName"
              bindValue="id"
              placeholder="Select"
              formControlName="area"
              class="ng-select control role-select"
            >
            </ng-select>

            }
            <app-error-message
              [form]="form"
              controlName="area"
              label="area"
              [showErrorMessage]="showErrorMessages"
            ></app-error-message>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-actions-wrapper">
      <button
        type="submit"
        class="custom-btn-primary w-100"
        [disabled]="form.invalid || isSubmitting"
      >
        <ng-container *ngIf="!isSubmitting; else loadingTemplate">
          <span>Create park</span>
        </ng-container>
        <ng-template #loadingTemplate>
          <span>Creating park...</span>
        </ng-template>
      </button>
    </div>
  </form>
</div>
